import { Injectable } from "@angular/core";
import {
  BoneLossSeverityTypes,
  CariesStageTypes,
  FindingType,
  RenderableFindingBase,
} from "@kells/interfaces/finding";
import { LabelBoxColors } from "../models/label-box.model";

@Injectable({
  providedIn: "root",
})
export class CanvasFindingService {
  constructor() {}

  /**
   * Given a finding, return the color that should be used for rendering
   * its label box (per-finding-type brand colors; caries is a single red).
   */
  static resolveLabelBoxColor<F extends RenderableFindingBase>(
    finding: F
  ): LabelBoxColors {
    if (!finding) {
      return LabelBoxColors.Caries;
    }
    let color: LabelBoxColors = LabelBoxColors.Caries;
    switch (finding.type) {
      case FindingType.Tooth:
        color = LabelBoxColors.Tooth;
        break;
      case FindingType.Fracture:
        color = LabelBoxColors.Fracture;
        break;
      case FindingType.Calculus:
        color = LabelBoxColors.Calculus;
        break;
      case FindingType.Infection:
        color = LabelBoxColors.Infection;
        break;
      case FindingType.DefectiveRestoration:
        color = LabelBoxColors.DefectiveRestoration;
        break;
      case FindingType.Plaque:
        color = LabelBoxColors.Plaque;
        break;
      case FindingType.GumRecession:
        color = LabelBoxColors.GumRecession;
        break;
      case FindingType.GumInflammation:
        color = LabelBoxColors.GumInflammation;
        break;
      case FindingType.MissingTooth:
        color = LabelBoxColors.MissingTooth;
        break;
      case FindingType.Material:
        color = LabelBoxColors.MaterialBrand;
        break;
      case FindingType.Caries:
        color = LabelBoxColors.Caries;
        break;
      case FindingType.Dummy:
        color = LabelBoxColors.Tooth;
        break;
      case FindingType.BoneLoss:
        color = LabelBoxColors.BoneLoss;
        break;
      default:
        color = LabelBoxColors.Caries;
    }
    return color;
  }

  static resolveCarriesStageColor(stage: string) {
    switch (stage) {
      case CariesStageTypes.Moderate:
        return LabelBoxColors.CariesModerate;
      case CariesStageTypes.Advanced:
        return LabelBoxColors.CariesAdvanced;
      case CariesStageTypes.Initial:
      default:
        return LabelBoxColors.CariesInitial;
    }
  }

  static resolveBoneLossSeverityColor(severity: string) {
    switch (severity) {
      case BoneLossSeverityTypes.Moderate:
        return LabelBoxColors.BonelossModerate;
      case BoneLossSeverityTypes.Advanced:
        return LabelBoxColors.BonelossAdvanced;
      case BoneLossSeverityTypes.Initial:
      default:
        return LabelBoxColors.BonelossInitial;
    }
  }

  static isCancelMode = false;
  static getIsCancelMode = () => {
    return CanvasFindingService.isCancelMode;
  };

  static setIsCancelMode = () => {
    CanvasFindingService.isCancelMode = true;
    setTimeout(() => {
      CanvasFindingService.isCancelMode = false;
    }, 2000);
  };
}
